export const TipConfig = {
    provider: Symbol('TipProvider'),
    moduleName: 'Tip'
};
